import { hasShiftStarted } from '@wilson/activities/pipes';
import { Activity, ShiftState } from '@wilson/interfaces';
import { isShiftSubmittedOrAccepted } from '@wilson/non-domain-specific/shift-helpers/core';

export function requiresHeavyShiftDeleteConfirmation(
  state: ShiftState | undefined,
  activities: Activity[] | null | undefined,
): boolean {
  return isShiftSubmittedOrAccepted(state) || hasShiftStarted(activities ?? []);
}
